window.meta = window.meta || {};

function cookieConsentAccepted() {
    return !!(window.HF && window.HF.cookieConsentAllowed);
}

window.meta.track = function(eventData, user = null) {
    if (!eventData) return;
    if (!eventData.event) return;
    let { event, ...data } = eventData;
    let eventId = eventData.event + '_' + Date.now() + '_' + ((crypto && crypto.randomUUID) ? crypto.randomUUID().replace(/-/g, '').slice(0, 8) : Math.random().toString(36).substring(2, 10));
    eventData.event_id = eventId;

    let submitData = {
        event_name: eventData.event,
        properties: Object.keys(data).length ? JSON.stringify(data) : null,
        event_id: eventId,
        user: cookieConsentAccepted() ? user : null,
    };

    if (user && cookieConsentAccepted()) {
        if(user.id) {
            eventData.user_id = user.id;
        }
        if (user.username) {
            eventData.email = user.username;
        }
        if (user.first_name) {
            eventData.first_name = user.first_name
        }
        if (user.last_name) {
            eventData.last_name = user.last_name
        }
        if (user.phone) {
            eventData.phone = user.phone
        }
        if (user.currency) {
            eventData.currency = user.currency
        }
        if (user.purchaseValue) {
            eventData.value = user.purchaseValue
        }
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json' 
        },
        body: JSON.stringify(submitData),
        credentials: 'same-origin'
    };

    let token = document.head.querySelector('meta[name="csrf-token"]');

    if (token) {
        options.headers['X-CSRF-TOKEN'] = token.content;
    } 

    let url = '/api/analytics/track';
    if (window.HF && window.HF.isApp) {
        url = window.HF.hfHost + url;
    }

    fetch(url, options).then( r=> {}).catch(e => {});
};